// extracted by mini-css-extract-plugin
export default {"header":"eacb852553e8","container":"eb7fb592ea07","tableContainer":"cd5124371ce0","pagination":"b326061f94ba","noMatchingTeams":"a3aae9059916"};